import { z } from 'zod';
import { userRole } from './users.js';
export const userSchema = z.object({
    id: z.string().min(1),
    email: z.string().email(),
    name: z.string().min(1),
    firebaseAuthUid: z.string().min(1),
    role: userRole,
    createdAt: z.string(),
    updatedAt: z.string(),
});
